import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { ISkeletonDashboard } from './Types';

const ImageDashBoardSkeleton = ({noItems}: ISkeletonDashboard) => {
  return (
    <>
      <Box display='flex' justifyContent='flex-start' 
        gap={'45px'} flexWrap='wrap'
        m={3}>
        {[...Array(noItems)].map((_, key) => {
          return (
            <>
              <Box key={key} flexDirection='column'>
                <Skeleton variant='rectangular'
                  width='323px'
                  height='250px' sx={{ borderRadius: '20px', minHeight: '250px', maxWidth: '323px', maxHeight: '250px', minWidth: '200px'}}
                />
                <Skeleton />
                <Skeleton width='60%' />
              </Box>
            </>
          );
        })
        }
      </Box>
    </>
  );
};

export default ImageDashBoardSkeleton;